import React from "react";
import { Skeleton } from "antd-mobile";
import { homeAtom } from "@/atoms/home";
import BaseCard from "./BaseCard";

// 骨架屏样式常量
const SKELETON_STYLES = {
  current4: { "--width": "100%", "--height": "839px", "--border-radius": "10px" },
};
// 今日详情
const TodayDetail: React.FC<any> = () => {
  const homeData = useAtomValue(homeAtom);
  const { current = {} } = homeData?.data ?? {};

  if (isEmptyType(current)) {
    return <Skeleton animated style={SKELETON_STYLES.current4} />;
  }
  return <BaseCard itemList={current?.Items} />;
};

export default TodayDetail;
